import { Component, OnInit } from '@angular/core';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { ShipImagesService } from 'src/app/Services/ship-images.service';

type bannerimage = { shpid: Int16Array; dplDeck: string; dplImage: string };

@Component({
  selector: 'app-ship-banner',
  templateUrl: './ship-banner.component.html',
  styleUrls: ['./ship-banner.component.css'],
})
export class ShipBannerComponent implements OnInit {
  userdata?: UserData;
  shpid: number | undefined;
  OBPortalSvcURL = '';
  imagepath = '';

  bannerimages: bannerimage[] | undefined;
  bannerimagedata: any;

  constructor(
    private appConfigService: AppConfigService,
    private shipImageService: ShipImagesService
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.shpid = this.userdata?.shipid!;
    this.imagepath = this.appConfigService.imagepath;
    this.getBannerImage();
  }
  getBannerImage() {
    this.bannerimagedata = this.shipImageService
      .getShipImages(this.shpid, 'Banner')
      .subscribe((bannerimagedata) => this.setBannerImage(bannerimagedata));
  }

  setBannerImage(resdata: any) {
    this.bannerimagedata = resdata;
    if (this.bannerimagedata.GetShipImages.Result.Status == 'A') {
      this.bannerimages = this.bannerimagedata.GetShipImages.ShipImagesList;
    }
  }
}
